import { render, staticRenderFns } from "./scoreFive.vue?vue&type=template&id=65f543fe"
import script from "./scoreFive.vue?vue&type=script&lang=js"
export * from "./scoreFive.vue?vue&type=script&lang=js"
import style0 from "./scoreFive.vue?vue&type=style&index=0&id=65f543fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports